const AppId={
    GuestService:"9"
  }


const DegreeOfRelativity=
{
    //" فرزند"
    child:0,
    //" همسر"
    Wife:1,
    //"پدر "
    Father:2,
    //"مادر "
    Mom:3,
    //"مادرهمسر "
    WifeMother:4,
    //"پدر همسر"
    WifeFather:5,
    //"نفر اصلی"
    agent:6
}
const AgeTypeArabian=
{
    //[Display(Name = "بالاي 12 سال")]
    adult : 1,
    //[Display(Name = "7 تا 12 سال")]
    Young : 2,
    //[Display(Name = "2 تا 7 سال")]
    minor :3,
    //[Display(Name = "زیر 2 سال")]
    child :4,
    //[Display(Name = "نامشخص")]
    NUll : 99
}


const GuestServices=
{
    //[Display(Name = "ویزا")]
    Visa:0,
    //[Display(Name = "اقامت")] 
    Plan:1,
    //[Display(Name = "تغذیه")] 
    Nutrition:2,
    //[Display(Name = "حمل و نقل")]
    Transfer:3,
    //[Display(Name = "پرواز")] 
    Flight:4,
}

const GuestServiceType=
{
    //[Display(Name = "ویزا")]
    Visa : 0,

    //[Display(Name = "دو تخته ")]
    DoubleBed : 10,
    //[Display(Name = "سه تخته ")]
    ThreeBeds : 11,

    //[Display(Name = "صبحانه ")]
    Breakfast : 20,
    //[Display(Name = "ناهار ")]
    Launch : 21,
    //[Display(Name = "شام ")]
    Dinner : 22,
    //[Display(Name = "افطار ")]
    Iftar : 23,
    //[Display(Name = "سحر ")]
    dawn : 24,

    //[Display(Name = "درون شهری ")]
    InnerCity : 30,
    //[Display(Name = "برون شهری ")]
    InterCity : 31,

    //[Display(Name = "ایران به عربستان ")]
    IranSaudiArabia : 40,
    //[Display(Name = "عربستان به ایران ")]
    SaudiArabiaIran : 41,
}

const FileAttachmentType=
{
    //[Display(Name = "صفحه اول گذرنامه")] 
    PassportImage:0,
    //[Display(Name = "مهر ورود گذرنامه")] 
    ReturnPassFile:1,
}


const CityConsistency=
{
    //"شهر پیش فرض عربستان"
    DefaultArabiaCity:0,
    //"شهر پیش فرض ایران"
    DefaultPersianCity:1,
    //"مکه "
    Mecca:2,
    //"مدینه "
    Medina:3,
    //"جده"
    Jeddah:4,
    //"طائف"
    Taif:5
}

const Operation =
{
    //[Display(Name = "عملیات 1403")]
    Operation1403:0,
    //[Display(Name = "عملیات 1404")]
    Operation1404:1,
    //[Display(Name = "عملیات 1405")]
    Operation1405:2,
    //[Display(Name = "عملیات 1406")]
    Operation1406:3,
    //[Display(Name = "عملیات 1407")]
    Operation1407:4,
    //[Display(Name = "عملیات1408")]
    Operation1408:5,
    //[Display(Name = "عملیات 1409")]
    Operation1409:6
}

const enumMapper={AppId, DegreeOfRelativity, AgeTypeArabian, GuestServices, FileAttachmentType, CityConsistency, GuestServiceType, Operation}
export default enumMapper